<template>
  <div-box>
    <nav-bar left-arrow :title="$t('节点记录')" />
    <vant-up-down ref="list" @list="(val) => (list = val)" res="res.data.data" :noToken="false"
      url="/api/v1/user/invest" :data="{}">
      <div-padding padding="4vw">
        <div-card bg='#242424' padding='3vw' margin="0 0 3vw 0" v-for="(item, index) in list" :key="index">
          <div-flex>
            <div-text color='#fff' size='4vw'>{{ $t('节点数量') }}</div-text>
            <div-text color='#CEB082' size='4vw'>+{{ item.give_amount }}</div-text>
          </div-flex>
          <van-divider style="margin:3vw 0" />
          <div-flex left>
            <div-text color='#999999' size='3.5vw'>{{ $t('是否有效') }}：</div-text>
            <div-text color='#CEB082' size='3.5vw'>{{ [$t('无效节点'), $t('有效节点')][item.is_valid] }}</div-text>
          </div-flex>
          <div-text color='#999' size='3.5vw'>{{ $t('购买时间') }}：{{ item.created_at }}</div-text>
        </div-card>
      </div-padding>
    </vant-up-down>
  </div-box>
</template>

<script>
  export default {
    data() {
      return {
        list: [],
      }
    },
    created() {
      this.up_down()
    },
    methods: {},
  }
</script>
<style lang='less' scoped>
  .item {
    width: 100%;
    background: #242424;
    border-radius: 6px;
    display: flex;
    justify-content: flex-start;
    img {
      width: 11vw;
      height: 11vw;
      margin-right: 3vw;
    }
    .top {
      width: 72vw;
      display: flex;
      justify-content: space-between;
      .top1 {
        font-size: 4vw;
        color: #fff;
        font-weight: 500;
      }
      .top2 {
        font-size: 3.5vw;
        color: #999999;
      }
      .top3 {
        font-size: 4vw;
        color: #ceb082;
      }
    }
  }
</style>